import React, { Component } from 'react';

export default class Ecsuite extends Component {
  constructor(props) {
    super(props);
    this.id = props.appendId ? `id${props.appendId}` : 'systemId'
  }
  componentDidMount(){
    let id = this.props.viewModel.get('id').getValue()
    // YYCooperationBridge.YYInit(
    //   {qzId: 105360}
    // )
    YYCooperationBridge && YYCooperationBridge.YYRenderCooperation({
        el: `#${this.id}`,
        objectName: 'U8C', // 单据类型 菜单名称
        objectId: id, // 单据ID 主表id
        qzId: '',
        memberId: '',
        commentConfig: {

        }
    })
  }

  render() {
    return (
        <div id={this.id}></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/Ecsuite.jsx